import { CombinedVueInstance } from "vue/types/vue";

export default abstract class ValidationModule {
  public pageNumber!: number; // module identifier
  public pageName!: string; // module identifier
  public alertTypes!: any; // use it to separate or filter alerts before requesting them. it basically maps a group of alerts to a common replaceable string
  public alertNames!: Array<string>; // keys of the alerts the module listens to
  public validating!: boolean; // set to true while Validate is running, false otherwise
  public validated!: boolean; // final result of validation, false default
  public validationMade!: boolean; // sets to true if validation had been triggered, false default
  public validationErrors!: Array<string>; // list of ids in case a more in-detail track of validation errors is required
  public component!: CombinedVueInstance<any, any, any, any, any>; // useful for automating store calls //set to protected and restrict access in later version to prevent recursion

  protected constructor(pageName: string) {
    this.validating = false;
    this.pageName = pageName;
    if (this.pageName === "Search") {
      this.pageNumber = 1;
    } else if (this.pageName === "Costs") {
      this.pageNumber = 2;
    } else if (this.pageName === "Details") {
      this.pageNumber = 3;
    } else if (this.pageName === "Contents") {
      this.pageNumber = 4;
    } else if (this.pageName === "Payment") {
      this.pageNumber = 5;
    } else {
      this.pageNumber = 0; // validation for global site
    }
  }

  public abstract Validate(scope: string): Promise<any>; // fires the whole validation process for the module's step
  public abstract resetValidations(/* -need scope here, because we need a way to be able to tell the reseter that a particular set of errors needs to be kept- */): void; // cleans up validation flags
  // errorsBag communication
  public abstract requestAlert(data: any): void; // ask api for an alert definition, it then saves it to errorsBag.alertResponses and adds the key to errorsBag.activeNotices
  public abstract removeNotice(data: any): void; // removes an alert key from errorsBag.activeNotices
  public abstract addNotice(data: any): void; // add an alert key to errorsBag.activeNotices
  protected abstract getFilteredAlertKey(data: any, returnType: string): any;
}
